// is active parent check
export const isActiveParent = (data = [], path) => {
	if (data?.length !== 0) {
		return data?.some(({ items }) =>
			items?.some(
				(menu) =>
					menu.routePath?.split("/")[1]?.replace(/\/\d+/, "") ===
					path?.split("/")[1]?.replace(/\/\d+/, "")
			)
		);
	}
};

// is active parent childe check
export const isActiveParentChaild = (data = [], path) => {
	if (data && data?.length !== 0) {

		return data?.some(
			(menu) =>
				menu.routePath.replace(/\/\d+/, "") === path.replace(/\/\d+/, "")
		);
	}
};

// is active link check
export const isActiveLink = (menuPath, routePath) => {
	if (menuPath && routePath) {
		// ลบตัวเลขออกจาก path เช่น /shop/123 -> /shop
		const cleanMenuPath = menuPath.replace(/\/\d+/, "");
		const cleanRoutePath = routePath.replace(/\/\d+/, "");

		// ตรวจสอบว่า routePath มี menuPath อยู่ข้างหน้า (รองรับ shop/add)
		return cleanRoutePath.startsWith(cleanMenuPath);
	}
	return false;
	//   if (menuPath && routePath) {
	//     return menuPath.replace(/\/\d+/, "") === routePath.replace(/\/\d+/, "");
	//   }
};

// is active parent check
export const isActiveParentD = (data = [], path) => {
	if (data?.length !== 0) {
		return data?.some(({ items }) =>
			items?.some(
				(menu) =>
					menu.path?.split("/")[1]?.replace(/\/\d+/, "") ===
					path?.split("/")[1]?.replace(/\/\d+/, "")
			)
		);
	}
};

// is active parent childe check
export const isActiveParentChaildD = (data = [], path) => {
	if (data && data?.length !== 0) {
		console.log(data)

		return data?.some(
			(menu) =>
				menu.path.replace(/\/\d+/, "") === path.replace(/\/\d+/, "")
		);
	}
};

// is active link check
export const isActiveLinkD = (menuPath, routePath) => {
	if (menuPath && routePath) {
		return menuPath.replace(/\/\d+/, "") === routePath.replace(/\/\d+/, "");
	}
};
